module.exports = __webpack_public_path__ + "img/avatar6.d81ae1bd.png";